import { lazy } from 'react';
import negate from 'lodash/negate';

import { isAuthenticatedUserSelector, isLoadingUserSelector } from 'store/selectors/userSelectors';
import { importRetry } from 'utils/dynamicImport';
import { ERouteNames, ERoutePaths } from 'types/routes/enums';

const imports = {
  login: () => import('components/Login/Login'),
  register: () => import('components/Register/Register'),
  forgotPassword: () => import('components/ForgotPassword/ForgotPassword'),
  newPassword: () => import('components/NewPassword/NewPassword'),
  home: () => import('components/Home/Home'),
  // dashboard: () => import('components/Dashboard/Dashboard'),
  orders: () => import('components/Orders/Orders'),
  products: () => import('components/Products/Products'),
  productPreview: () => import('components/ProductPreview/ProductPreview'),
  payments: () => import('components/Payments/Payments'),
  messages: () => import('components/Messages/Messages'),
  settings: () => import('components/Settings/Settings'),
};

const commonRoutes = [
  {
    documentTitle: '',
    path: ERoutePaths.Root,
    exact: true,
    conditions: [negate(isLoadingUserSelector), isAuthenticatedUserSelector, negate(isAuthenticatedUserSelector)],
    redirects: ['', ERoutePaths.Login, ERoutePaths.Home],
    component: () => null,
  },
  {
    documentTitle: '',
    path: ERoutePaths.ShopifyCallback,
    exact: false,
    component: () => null,
  },
];

const publicRoutes = [
  {
    documentTitle: ERouteNames.Login,
    path: ERoutePaths.Login,
    exact: false,
    component: lazy(() => importRetry(imports.login)),
  },
  {
    documentTitle: ERouteNames.Register,
    path: ERoutePaths.Register,
    exact: false,
    component: lazy(() => importRetry(imports.register)),
  },
  {
    documentTitle: ERouteNames.ForgotPassword,
    path: ERoutePaths.ForgotPassword,
    exact: false,
    component: lazy(() => importRetry(imports.forgotPassword)),
  },
  {
    documentTitle: ERouteNames.NewPassword,
    path: ERoutePaths.NewPassword,
    exact: false,
    component: lazy(() => importRetry(imports.newPassword)),
  },
];

const privateRoutes = [
  {
    documentTitle: ERouteNames.Home,
    path: ERoutePaths.Home,
    exact: true,
    component: lazy(() => importRetry(imports.home)),
  },
  // {
  //   documentTitle: ERouteNames.Dashboard,
  //   path: ERoutePaths.Dashboard,
  //   exact: true,
  //   component: lazy(() => importRetry(imports.dashboard)),
  // },
  {
    documentTitle: ERouteNames.Products,
    path: ERoutePaths.Products,
    exact: true,
    component: lazy(() => importRetry(imports.products)),
  },
  {
    documentTitle: ERouteNames.ProductPreview,
    path: ERoutePaths.ProductPreview,
    exact: true,
    component: lazy(() => importRetry(imports.productPreview)),
  },
  {
    documentTitle: ERouteNames.Orders,
    path: ERoutePaths.Orders,
    exact: true,
    component: lazy(() => importRetry(imports.orders)),
  },
  {
    documentTitle: ERouteNames.Payments,
    path: ERoutePaths.Payments,
    exact: true,
    component: lazy(() => importRetry(imports.payments)),
  },
  {
    documentTitle: ERouteNames.Messages,
    path: ERoutePaths.Messages,
    exact: true,
    component: lazy(() => importRetry(imports.messages)),
  },
  {
    documentTitle: ERouteNames.Settings,
    path: ERoutePaths.Settings,
    exact: true,
    component: lazy(() => importRetry(imports.settings)),
  },
];

export const PUBLIC_ROUTES = [...commonRoutes, ...publicRoutes];
export const PRIVATE_ROUTES = [...commonRoutes, ...privateRoutes];
